// import '@tencent/particle-ui/dist/pui.css';
import '@tencent/cms-design-component/lib/dist/style/main.css';
import '@tencent/intl-design-ui/lib/scss/intl-ui.min.css';
// import { getEidList } from '../apis/cmsApi';
import { pageRenderer } from '../components/renderer';
export var __N_SSG = true;
// getStaticProps的ISR缓存在多域名下会串，暂时关闭ISR，不使用使用getStaticProps，改用getServerSideProps
// 后续优化方案：可通过不同域名在本服务里用不同path来区分域名，ISR支持不同path区分
// export const getServerSideProps = async (context) => {
//   const {
//     locale,
//     defaultLocale,
//     params: { eid },
//     preview = false,
//     req,
//   } = context;
//   const domains = handleRequestHosts(req);
//   const data = await getData({ locale, defaultLocale, eid, isPreview: preview, domains });
//   const cdnDataUpdate = await modifyCdn(data);
//   return { ...JSON.parse(cdnDataUpdate) };
// };
export default function Renderer(props) {
    return pageRenderer(props);
};
